import React from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { useTranslation } from 'react-i18next'
import { Field, submit } from 'redux-form'
import { Row, Col, Tooltip } from 'antd'
import { useDispatch } from 'react-redux'

// atoms
import InputField from './InputField'

// assets
import { ReactComponent as DragIcon } from '../assets/icons/BaseIcons/drag-icon.svg'
import { ReactComponent as CloseIcon } from '../assets/icons/BaseMiniIcons/x.svg'

// enums
import { ELEMENT_TYPES } from '../utils/enums'

// helpers
import { validateRequired } from '../utils/helper'

interface DragAndDropOptionsProps {
	data: any
	formType: any
	disabled?: boolean
	optionsType?: string
}

function DragAndDropOptions(props: DragAndDropOptionsProps) {
	const { data, disabled, formType, optionsType } = props
	const { t } = useTranslation()
	const dispatch = useDispatch()

	return (
		<Droppable droppableId={'droppableId'}>
			{(firstProvider) => (
				<div
					className='list'
					ref={firstProvider.innerRef}
					data-rbd-droppable-context-id={firstProvider.droppableProps['data-rbd-droppable-context-id']}
					data-rbd-droppable-id={firstProvider.droppableProps['data-rbd-droppable-id']}
				>
					{data.map((item: any, index: number) => (
						<Draggable key={index} draggableId={`${index}`} index={index}>
							{(secondProvider, snapshot) => (
								<div
									className='item'
									ref={secondProvider.innerRef}
									tabIndex={secondProvider?.dragHandleProps?.tabIndex}
									role={secondProvider?.dragHandleProps?.role}
									aria-describedby={secondProvider?.dragHandleProps?.['aria-describedby']}
									data-rbd-drag-handle-draggable-id={secondProvider?.dragHandleProps?.['data-rbd-drag-handle-draggable-id']}
									data-rbd-drag-handle-context-id={secondProvider?.dragHandleProps?.['data-rbd-drag-handle-context-id']}
									draggable={secondProvider?.dragHandleProps?.draggable}
									onDragStart={secondProvider?.dragHandleProps?.onDragStart}
									data-rbd-draggable-context-id={secondProvider?.draggableProps?.['data-rbd-draggable-context-id']}
									data-rbd-draggable-id={secondProvider?.draggableProps?.['data-rbd-draggable-id']}
									style={{
										...secondProvider?.draggableProps?.style,
										background: snapshot.isDragging ? '#ccc' : '#fff'
									}}
									onTransitionEnd={secondProvider?.draggableProps?.onTransitionEnd}
								>
									{optionsType === ELEMENT_TYPES.TAB_BOX ? (
										<Tooltip placement='left' title={data.get(index)?.key}>
											<Row key={index} justify={'center'} className={'flex items-center mb-1 w-full bg-gray-25 options-drag-item'}>
												<Col span={22}>
													<Field
														component={InputField}
														placeholder={t('loc:Enter title')}
														name={`${item}.title`}
														size={'medium'}
														disabled={disabled}
														className={'m-px'}
														validate={validateRequired}
													/>
												</Col>
												<Col span={2} className={'h-5'}>
													<DragIcon className={'cursor-move w-5 h-5'} />
												</Col>
											</Row>
										</Tooltip>
									) : (
										<Row key={index} justify={'center'} className={'flex py-2 items-center mb-1 w-full bg-gray-100 rounded-md'}>
											<Col span={2} className={'h-5'}>
												<DragIcon className={'cursor-move w-5 h-5'} />
											</Col>
											<Col span={20}>
												<div className={'flex items-center h-6 options-drag-item'}>
													<p className={'m-0 pr-2'}>{t('loc:Label')}</p>
													<Field
														component={InputField}
														placeholder={t('loc:Enter label')}
														name={`${item}.label`}
														size={'medium'}
														disabled={disabled}
														className={'dndInput m-px'}
														validate={validateRequired}
													/>
												</div>
												<div className={'flex items-center h-6 options-drag-item'}>
													<p className={'m-0 pr-2'}>{t('loc:Value')}</p>
													<Field
														component={InputField}
														placeholder={t('loc:Enter value')}
														name={`${item}.value`}
														size={'medium'}
														disabled={disabled}
														className={'dndInput m-px'}
														validate={validateRequired}
													/>
												</div>
											</Col>
											<Col span={2} className={'h-5'}>
												<CloseIcon
													className={'cursor-pointer w-5 h-5'}
													onClick={async () => {
														await data.remove(index)
														dispatch(submit(formType))
													}}
												/>
											</Col>
										</Row>
									)}
								</div>
							)}
						</Draggable>
					))}
					{firstProvider.placeholder}
				</div>
			)}
		</Droppable>
	)
}

export default DragAndDropOptions
